import { observable } from 'mobx';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { Counter, ICounter } from '~domain/entities/Counter';

export interface ICounterMap {
    [id: string]: Counter;
}

const mapCounterById = (data: ICounterMap, counterData: ICounter) => ({
    ...data,
    [counterData.id]: new Counter(counterData)
});

export class CounterRepository {
    @observable public counters: ICounterMap;

    public loadCounters = async () => {
        if (!this.counters) {
            const countersData = await query(serviceQueries.GET_APPT_BOOKING_COUNTERS, {});
            this.counters = countersData.reduce(mapCounterById, {});
        }
    };
}
